import * as types from "./mtypes";
import axios from "axios";
import {
  handleRequest,
  handleMultiRequest,
} from "@/store/utils/requestFunctions";
import * as endpoints from "@/store/constants/endpoints";

export default {
  async getAllAcounts({ commit }, query) {
    await handleMultiRequest(
      commit,
      (params) =>
        axios.get(`${endpoints.USERS}${query}`, { params: { ...params } }),
      types.FETCH_ALL_ACCOUNT_SUCCESS,
      types.REQUEST_FAILURE,
    );
  },

  async getAccounts({ commit }, params) {
    await handleRequest(
      commit,
      () => axios.get(`${endpoints.USERS}${params}`),
      types.FETCH_ACCOUNT_SUCCESS,
      types.FETCH_ACCOUNT_FAILURE,
    );
  },

  async addUser({ commit }, user) {
    await handleRequest(
      commit,
      () => axios.post(`${endpoints.USERS}`, user),
      types.REQUEST_SUCCESS,
      types.REQUEST_FAILURE,
    );
  },

  async getPasswd({ commit }, payload) {
    await handleRequest(
      commit,
      () => axios.post(`${endpoints.USERS}/DecriptPassword`, payload),
      types.FETCH_PLAIN_PASSWORD,
      types.REQUEST_FAILURE,
    );
  },

  async updatePasswd({ commit }, payload) {
    await handleRequest(
      commit,
      () => axios.post(`${endpoints.AUTH_LOGIN}/ResetPassword`, payload),
      types.RESET_PASSWORD,
      types.REQUEST_FAILURE,
    );
  },

  async addPermissionsToUser({ commit }, instance) {
    await handleRequest(
      commit,
      () =>
        axios.put(`${endpoints.USERS}${endpoints.PERMISSIONS}/add`, instance),
      types.REQUEST_SUCCESS,
      types.REQUEST_FAILURE,
    );
  },

  async removePermissionsToUser({ commit }, instance) {
    await handleRequest(
      commit,
      () =>
        axios.put(
          `${endpoints.USERS}${endpoints.PERMISSIONS}/remove`,
          instance,
        ),
      types.REQUEST_SUCCESS,
      types.REQUEST_FAILURE,
    );
  },
};
